const SAFARI_BACKGROUND_ERRORS = [
  'Load failed',
  'cancelled',
  'The network connection was lost',
];

const isSafariBackgroundRequestFail = (error: unknown): boolean => {
  if (!(error instanceof TypeError)) return false;
  return SAFARI_BACKGROUND_ERRORS.some((msg) => error.message.includes(msg));
};

export default isSafariBackgroundRequestFail;
